<section class="main-noda">
  <div class="container">
    <div class="main-noda__header">
      <h2 class="heading-2-v2 main-noda__title">
        <noda-translate [key]="'main-v2.what-is-noda.title'" />
        <span>Noda?</span>
      </h2>
      <p class="text-2-v2 main-noda__text">
        <noda-translate [key]="'main-v2.what-is-noda.text'" />
      </p>
      <noda-button-v2
        appearance="flat--dark-mode"
        text="common.call-to-action.get-started"
        class="main-noda__btn"
        [icon]="{ position: 'right', name: 'arrow_drop_right' }"
        [link]="buttonLink"
      />
    </div>
    <div class="main-swiper__wrapper">
      <div class="swiper__container">
        <swiper [config]="config">
          @for (slide of whatIsNodaSwiper; track $index) {
            <ng-template swiperSlide>
              <div
                *nodaResponsiveIf="['(max-width: 1023.9px)']"
                class="slide slide{{ $index + 1 }}"
              >
                <h4 class="heading-4-v2 slide__subtitle">
                  <noda-translate [key]="slide.subtitle" />
                </h4>
                <h2 class="heading-2-v2 slide__title">
                  <noda-translate [key]="slide.title" />
                </h2>
                <p class="text-2-v2 slide__text">
                  <noda-translate [key]="slide.text" />
                </p>
                <picture class="slide__img">
                  <source
                    media="(min-width: 1440px)"
                    [srcset]="'main/what-is-noda/' + slide.image + '-xxl.webp' | src: 'origin'"
                  />
                  <source
                    media="(min-width: 1024px)"
                    [srcset]="'main/what-is-noda/' + slide.image + '-lg.webp' | src: 'origin'"
                  />
                  <source
                    media="(min-width: 768px)"
                    [srcset]="'main/what-is-noda/' + slide.image + '-md.webp' | src: 'origin'"
                  />
                  <img
                    alt=""
                    [srcset]="'main/what-is-noda/' + slide.image + '.webp' | src: 'origin'"
                  />
                </picture>
                <noda-button-v2
                  btnSize="m"
                  class="slide__btn"
                  [icon]="icon"
                  [link]="slide.link"
                  [text]="slide.buttonText"
                />
              </div>
              <div
                *nodaResponsiveIf="[minWidthScreen.LG]"
                class="slide slide{{ $index + 1 }}"
              >
                <div class="slide__container">
                  <h4 class="heading-4-v2 slide__subtitle">
                    <noda-translate [key]="slide.subtitle" />
                  </h4>
                  <h2 class="heading-2-v2 slide__title">
                    <noda-translate [key]="slide.title" />
                  </h2>
                  <p class="text-2-v2 slide__text">
                    <noda-translate [key]="slide.text" />
                  </p>
                  <ng-container [ngTemplateOutlet]="info" />
                  <noda-button-v2
                    btnSize="l"
                    class="slide__btn"
                    [icon]="icon"
                    [isResizable]="false"
                    [link]="slide.link"
                    [text]="slide.buttonText"
                  />
                </div>
                <picture class="slide__img">
                  <source
                    media="(min-width: 1440px)"
                    [srcset]="'main/what-is-noda/' + slide.image + '-xxl.webp' | src: 'origin'"
                  />
                  <source
                    media="(min-width: 1024px)"
                    [srcset]="'main/what-is-noda/' + slide.image + '-lg.webp' | src: 'origin'"
                  />
                  <source
                    media="(min-width: 768px)"
                    [srcset]="'main/what-is-noda/' + slide.image + '-md.webp' | src: 'origin'"
                  />
                  <img
                    alt=""
                    [srcset]="'main/what-is-noda/' + slide.image + '.webp' | src: 'origin'"
                  />
                </picture>
              </div>
            </ng-template>
          }
        </swiper>
        <div class="swipe-btn-v2 swipe-btn-v2--left what-left">
          <svg-icon name="controls/arrow-right.svg#arrow-right" />
        </div>
        <div class="swipe-btn-v2 swipe-btn-v2--right what-right">
          <svg-icon name="controls/arrow-right.svg#arrow-right" />
        </div>
      </div>
      <div class="main-noda__pagination custom-pagination reviews__pagination"></div>
      <ng-container
        *nodaResponsiveIf="[enMaxWidthScreen.LG]"
        [ngTemplateOutlet]="info"
      />
    </div>
  </div>
</section>
<ng-template #info>
  <div class="info">
    @for (item of whatIsNodaInfo; track $index) {
      <div class="info__item item">
        <div class="item__wrapper">
          <svg-icon
            class="item__icon"
            [name]="getIconName(item.icon)"
            [size]="32"
          />
          <h3 class="item__title">
            <noda-translate [key]="item.title" />
          </h3>
        </div>
        <p class="item__text">
          <noda-translate [key]="item.text" />
        </p>
      </div>
    }
  </div>
</ng-template>
